import { requestFitplus } from '@/api';
import type { AdminLoginResponse } from '../types/adminLogin';
import type { ApiResponse } from '../types/response';

const endPoint = {
    POST_SECURE_LOGIN: 'backoffice/login',
    POST_AUTO_LOGIN: 'backoffice/auto-login',
};

export const postSecureLoginApi = async (
    LoginID: string,
    LoginPW: string,
): Promise<ApiResponse<AdminLoginResponse>> => {
    const resp = await requestFitplus<AdminLoginResponse>(endPoint.POST_SECURE_LOGIN, 'post', {
        LoginID,
        LoginPW,
    });

    return resp;
};

export const postAutoLoginApi = (): Promise<ApiResponse<AdminLoginResponse>> => {
    return requestFitplus<AdminLoginResponse>(endPoint.POST_AUTO_LOGIN, 'post');
};
